import React from 'react'
import cx from 'classnames'

import { renderModules } from '@/utls.js'

import META from '@/meta.js'
import HomeHero from '@/heros/homeHero.js'
import Footer from '@/footer.js'
import ComingSoon from '@/modules/comingSoon.js'
import { queryHome } from '../utls/queryHome.js'
import ThemeProvider from '@/themeProvider.js'

const Home = ({ transitionStatus, entry, exit }) => {
  const data = queryHome()
  const metaData = {
    title: data.metaInfo ? data.metaInfo.title || data.title : data.title,
    keywords: data.metaInfo ? data.metaInfo.keywords || '' : '',
    description: data.metaInfo ? data.metaInfo.description || data.description : data.description,
    url: '',
    image: data.imageGrid[0].image,
    ogTitle: data.metaInfo ? data.metaInfo.title || data.title : data.title,
    ogDescription: data.metaInfo ? data.metaInfo.openGraphDescription || data.description : data.description,
    ogImage: data.metaInfo ? data.metaInfo.openImage || data.imageGrid[0].image : data.imageGrid[0].image,
    twitterImage: data.metaInfo ? data.metaInfo.twitterImage || data.imageGrid[0].image : data.imageGrid[0].image,
    twitterTitle: data.metaInfo ? data.metaInfo.twitterTitle || data.title : data.title,
    twitterDescription: data.metaInfo ? data.metaInfo.twitterDescription || data.description : data.description
  }
  return (
    <div className={cx('animate__page', transitionStatus)}>
      <META data={data} metaData={metaData} />
      <ThemeProvider color={`one`} page='home' />
      <div className='nav--spacer' />
      <HomeHero data={data} />
      {renderModules(data.modules)}
      <ComingSoon />
      <Footer />
    </div>
  )
}

export default Home
